import { render, staticRenderFns } from "./MapGame.vue?vue&type=template&id=47b79da2&scoped=true&"
import script from "./MapGame.vue?vue&type=script&lang=js&"
export * from "./MapGame.vue?vue&type=script&lang=js&"
import style0 from "./MapGame.vue?vue&type=style&index=0&id=47b79da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b79da2",
  null
  
)

export default component.exports